import { styled, Box } from "@mui/material";
import { Iconify } from "..";
import { useTranslations } from "next-intl";

interface ProgressTimelineDotProps {
  isActive: boolean;
  isCompleted: boolean;
}

const RootStyle = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isActive" && prop !== "isCompleted",
})<{ isActive?: boolean; isCompleted: boolean }>(
  ({ theme, isActive, isCompleted }) => ({
    backgroundColor:
      isActive || isCompleted
        ? theme.palette.primary.main
        : theme.palette.background.default,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "50%",
    boxShadow:
      isActive && !isCompleted
        ? "0px 0px 0px 4px rgba(158, 119, 237, 0.24)"
        : "",
    border:
      isActive || isCompleted ? "" : `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.down("md")]: {
      width: "1rem",
      height: "1rem",
    },
  }),
);

export const ProgressTimelineDot = ({
  isActive,
  isCompleted,
}: ProgressTimelineDotProps) => {
  return (
    <RootStyle isActive={isActive} isCompleted={isCompleted} zIndex={1}>
      {isCompleted ? (
        <Iconify
          icon="material-symbols:check"
          color="background.default"
          fontWeight="700"
          fontSize={{ xs: "0.8rem", md: "1.2rem" }}
        />
      ) : (
        <Box
          width={{ xs: "0.3rem", md: "0.6rem" }}
          height={{ xs: "0.3rem", md: "0.6rem" }}
          bgcolor={isActive ? "background.default" : "grey.100"}
          borderRadius="50%"
        />
      )}
    </RootStyle>
  );
};
